import { formatDistanceToNow, parseISO } from 'date-fns'
import { enGB } from 'date-fns/locale'

export function formatRelativeTime(isoTimestamp: string | null): string | null {
  if (isoTimestamp === null || isoTimestamp === '') {
    return null
  }
  const parsed = parseISO(isoTimestamp)
  if (Number.isNaN(parsed.getTime())) {
    return null
  }
  return formatDistanceToNow(parsed, { addSuffix: true, locale: enGB })
}
